module.exports = __webpack_public_path__ + "static/media/icon_direcionador_over.2084b42a.svg";